import * as Yup from "yup";

export default Yup.object().shape({
    id: Yup.number(),
    sampleNumber: Yup.string().required("Sample Number is Required"),
    sampleType: Yup.string().nullable(),
    sampleVolume: Yup.string().nullable(),
    colorDescription: Yup.string().nullable(),
    location: Yup.string().nullable(),
    cocNotes: Yup.string().nullable(),
    surface: Yup.string().nullable(),
});

